import * as Sentry from '@sentry/vue';

let sentryEnabled = false;

export function markSentryEnabled() {
  sentryEnabled = true;
}

export function isSentryEnabled() {
  return sentryEnabled;
}

export function setSentryUser(user) {
  if (!isSentryEnabled() || !user) {
    return;
  }

  const username =
    user.full_name ||
    [user.firstname, user.lastname].filter(Boolean).join(' ') ||
    undefined;

  Sentry.setUser({
    id: user.id != null ? String(user.id) : undefined,
    email: user.email,
    username,
    organization: user.organization,
  });
}

export function clearSentryUser() {
  if (!isSentryEnabled()) {
    return;
  }

  Sentry.setUser(null);
}

function resolveApiVersion(baseURL = '') {
  if (baseURL.includes('/api/v3/')) {
    return 'v3';
  }

  if (baseURL.includes('/api/v2/')) {
    return 'v2';
  }

  return 'unknown';
}

function shouldCaptureApiError(status) {
  return status != null && status >= 500;
}

export function captureApiError(error) {
  if (!isSentryEnabled() || !shouldCaptureApiError(error?.response?.status)) {
    return;
  }

  const config = error?.config || {};
  const status = error?.response?.status;
  const url = (config.url || '').split('?')[0];

  Sentry.withScope((scope) => {
    scope.setTag('http.status', status ?? 'network');
    scope.setTag('http.method', (config.method || 'get').toUpperCase());
    scope.setTag('http.url', url);
    scope.setTag('api', resolveApiVersion(config.baseURL));
    Sentry.captureException(error);
  });
}
